
export function tabStyle(isActive: boolean) {
  return {
    fontWeight: isActive ? 600 : 400,
    backgroundColor: isActive ? 'var(--mantine-primary-color-light)' : undefined,
    color: isActive ? 'var(--mantine-primary-color-light-color)' : undefined,
    borderColor: isActive ? 'var(--mantine-primary-color-light)' : 'transparent',
  };
}